// extracted by mini-css-extract-plugin
export default {"sign-up-button-icon":"styles_sign-up-button-icon__IQ3Xe","signUpButtonIcon":"styles_sign-up-button-icon__IQ3Xe"};